import { render, staticRenderFns } from "./GatewaySettingsLayout.vue?vue&type=template&id=6d20d40b&scoped=true&"
import script from "./GatewaySettingsLayout.vue?vue&type=script&lang=js&"
export * from "./GatewaySettingsLayout.vue?vue&type=script&lang=js&"
import style0 from "./GatewaySettingsLayout.vue?vue&type=style&index=0&id=6d20d40b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d20d40b",
  null
  
)

export default component.exports